import index from "./loader.vue";
export default index;
